import { Modal } from 'bootstrap'

let activeModals = []

export const showModal = (htmlContent, options = {}) => {
  return new Promise((resolve) => {
    const defaultOptions = {
      autoCloseSeconds: 3,
      persistent: false
    }
    
    const finalOptions = { ...defaultOptions, ...options }
    const lastFocusedElement = document.activeElement

    // Create modal container
    const modalContainer = document.createElement('div')
    modalContainer.innerHTML = `
      <div class="modal fade" tabindex="-1" aria-labelledby="dynamicModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered mx-auto">
          <div class="modal-content border-0 shadow">
            <div class="modal-body p-4 text-center">
              <span class="fw-medium">${htmlContent}</span>
            </div>
          </div>
        </div>
      </div>
    `

    document.body.appendChild(modalContainer)
    document.querySelectorAll('body > *:not(.modal)').forEach(el => el.setAttribute('inert', ''))

    const modalInstance = new Modal(modalContainer.querySelector('.modal'), {
      backdrop: 'static',
      keyboard: false
    })
    
    activeModals.push(modalInstance)
    modalInstance.show()

    if (!finalOptions.persistent) {
      setTimeout(() => {
        modalInstance.hide()
      }, finalOptions.autoCloseSeconds * 1000)
    }

    modalContainer.querySelector('.modal').addEventListener('hidden.bs.modal', () => {
      document.body.removeChild(modalContainer)
      document.querySelectorAll('body > *:not(.modal)').forEach(el => el.removeAttribute('inert'))
      if (lastFocusedElement) {
        lastFocusedElement.focus()
        document.body.style.overflowX = 'hidden'
      }
      activeModals = activeModals.filter(m => m !== modalInstance)
      resolve() // Resolve the promise when modal is hidden
    })

    document.body.style.overflowX = 'hidden'
  })
}

export const cleanupModals = () => {
activeModals.forEach(modal => {
    modal.hide()
})
activeModals = []
}
